import React from 'react';
import Select from '../../../../../../components/input/Select/Select';
import DateRangePicker from '../../../../../../components/datePicker/DateRangePicker';
import OpenBrandDetail from '../../../../../../components/link/OpenBrandDetail';
import TableFilterInput from '../../../../../../components/table/TableFilterInput';
import {
  DATE_FORMAT,
  DATE_PICKER_FULL_DASH_FORMAT_PLACEHOLDER_TEXT,
} from '../../../../../../constants/service/common/utilConstants';
import {
  ACCOUNT_USER_DETAIL_LIKE_BRAND_LOG_LIST_ACTION_LOG_TYPE,
  ACCOUNT_USER_DETAIL_LIKE_BRAND_LOG_LIST_ACTION_LOG_TYPE_SELECT_LIST,
  ACCOUNT_USER_DETAIL_LIKE_BRAND_LOG_LIST_ACTION_LOG_TYPE_TEXT,
} from '../../../../../../constants/service/app/accountUserConstants';
import { addAllItemToSelectList } from '../../../../../../lib/common';
import { setDateFormat } from '../../../../../../lib/moment';
import TableColumnImg from '../../../../../../components/table/TableColumnImg';

const columns = (data) => {
  const { filterOption, onFilter } = data;

  return [
    {
      accessor: 'no',
      Header: '순번',
      width: 80,
      Cell: (row) => row.value,
    },
    {
      accessor: 'url',
      Header: '대표 이미지',
      width: 120,
      Cell: (row) => <TableColumnImg url={row.value} />,
    },
    {
      accessor: 'storeId',
      Header: '브랜드 ID',
      filterable: true,
      width: 100,
      Cell: (row) => <OpenBrandDetail text={row.value} storeId={row.value} />,
      Filter: () => <TableFilterInput option={filterOption.storeId} onFilter={(storeId) => onFilter({ storeId })} />,
    },
    {
      accessor: 'storeName',
      Header: '브랜드명',
      filterable: true,
      Cell: (row) => <OpenBrandDetail text={row.value} storeId={row.original.storeId} />,
      Filter: () => (
        <TableFilterInput option={filterOption.storeName} onFilter={(storeName) => onFilter({ storeName })} />
      ),
    },
    {
      accessor: 'actionLogType',
      Header: '활동 내역',
      filterable: true,
      Cell: (row) =>
        row.value === ACCOUNT_USER_DETAIL_LIKE_BRAND_LOG_LIST_ACTION_LOG_TYPE.CLICK
          ? ACCOUNT_USER_DETAIL_LIKE_BRAND_LOG_LIST_ACTION_LOG_TYPE_TEXT[row.value]
          : `브랜드 ${ACCOUNT_USER_DETAIL_LIKE_BRAND_LOG_LIST_ACTION_LOG_TYPE_TEXT[row.value]}`,
      Filter: () => (
        <Select
          list={addAllItemToSelectList(ACCOUNT_USER_DETAIL_LIKE_BRAND_LOG_LIST_ACTION_LOG_TYPE_SELECT_LIST)}
          onChange={(actionLogType) => onFilter({ actionLogType })}
          value={filterOption.actionLogType}
          isTable
          size="large"
        />
      ),
    },
    {
      accessor: 'createDate',
      Header: '활동 시간',
      filterable: true,
      sortable: true,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.FULL_DASH_FORMAT),
      Filter: () => (
        <DateRangePicker
          value={filterOption.createDate}
          showTime={true}
          btnTextFormat={DATE_FORMAT.FULL_DASH_FORMAT}
          startText={DATE_PICKER_FULL_DASH_FORMAT_PLACEHOLDER_TEXT}
          endText={DATE_PICKER_FULL_DASH_FORMAT_PLACEHOLDER_TEXT}
          outFormat={DATE_FORMAT.FULL_DASH_FORMAT}
          format={DATE_FORMAT.FULL_DASH_FORMAT}
          onSelect={(data) => onFilter({ createDate: data })}
        />
      ),
    },
  ];
};

export default columns;
